import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { zServiceProjectTask } from "@dobrh-monorepo/core";

const requestSchema = z.object({
  date: z.string().refine((value) => !isNaN(Date.parse(value))),
  type: z
    .union([z.literal("ongoing"), z.literal("completed"), z.literal("todo"), z.literal("overdue")])
    .optional(),
  searchText: z.string().optional(),
});

const responseType = z.object({
  count: z.number(),
  list: z.array(zServiceProjectTask),
});

export default {
  method: HttpMethodEnum.GET,
  paramsType: HttpParamsTypeEnum.QUERY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseType,
} satisfies Route;
